import { offeredBookTemplates } from "./catalog.js";
import { bookCreationProfileForTemplate } from "./creation-profile.js";
export const BOOK_VOUCHER_PRODUCT_ID = "book-voucher";
export const BOOK_VOUCHER_REFERENCE_EDITION_ID = "story";
/** Stable operations identity for the one-price direct book-voucher product. */
export const BOOK_VOUCHER_ADMIN_OFFER_ID = "01K60000000000000000000001";
/**
 * Editions a voucher starts although their creation profile is still labelled Sandbox: Bedtime,
 * the bounded launch family, and (owner decision 4, 2026-10-15) the comic book and the family
 * cookbook. A voucher issued before keeps the editions it was issued with.
 */
const VOUCHER_EDITIONS_ON_SANDBOX_WORKFLOWS = new Set([
    "children",
    "comic",
    "recipes",
]);
/**
 * The product is a voucher for one customer-selected book, not a direct book
 * order. Keep this list derived from the same production-readiness contract
 * that gates Studio creation so redemption cannot offer a dead-end edition.
 * Bedtime is the bounded launch family: its authenticated workflow is enabled
 * for voucher-backed production even while the broader catalog still labels
 * the creation profile as Sandbox. Print eligibility remains a separate,
 * evidence-derived decision at order time.
 */
export const bookVoucherEligibleTemplates = offeredBookTemplates.filter((template) => {
    const profile = bookCreationProfileForTemplate(template.id);
    const ownerApproved = VOUCHER_EDITIONS_ON_SANDBOX_WORKFLOWS.has(template.id);
    return (profile?.registration === "CURRENT_CATALOG" &&
        (profile.readiness === "AVAILABLE_WORKFLOW" ||
            (ownerApproved && profile.readiness === "SANDBOX_WORKFLOW")) &&
        (profile.availability === "WORKING" || (ownerApproved && profile.availability === "SANDBOX")));
});
/**
 * Whether a book voucher starts this edition today. Every customer book begins from a redeemed
 * voucher, so an edition no voucher starts shows its example instead.
 */
export function bookVoucherStartsEdition(templateId) {
    const availability = bookCreationProfileForTemplate(templateId)?.availability;
    return (bookVoucherEligibleTemplates.some(({ id }) => id === templateId) &&
        (availability === "WORKING" || availability === "SANDBOX"));
}
/** One customer-visible price for every eligible book type. */
export const BOOK_VOUCHER_PRICE_MINOR = 7_999;
export const BOOK_VOUCHER_PRICE_USD = BOOK_VOUCHER_PRICE_MINOR / 100;
export const BOOK_VOUCHER_PRICE_DISPLAY = "$79.99";
export const BOOK_VOUCHER_INCLUDED_PRINT_COPIES = 1;
export const BOOK_VOUCHER_INCLUDED_SHIPPING = "STANDARD_US_ONLY";
export const BOOK_VOUCHER_EXPRESS_SHIPPING_OFFERED = false;
if (bookVoucherEligibleTemplates.length < 2 ||
    !bookVoucherEligibleTemplates.some((template) => template.id === BOOK_VOUCHER_REFERENCE_EDITION_ID)) {
    throw new Error("BOOK_VOUCHER_CATALOG_INVALID");
}
//# sourceMappingURL=book-voucher.js.map